export default __webpack_public_path__ + "9a00bf2bf43a0b32f43b247e5d60eb96.png";